import React from 'react';
import { Alert } from 'antd';
import { useHistory } from 'react-router-dom';

import { useCurrentSubscription } from 'hooks';
import { SubscriptionStatus } from 'redux/reducers/authReducer';

export function FreeTrialBanner() {
  const subscription = useCurrentSubscription();
  const history = useHistory();

  if (subscription.status !== SubscriptionStatus.Unsubscribed) {
    return <></>;
  }

  const buttonProps = {
    showIcon: true,
    onClick: () => history.push('/subscription'),
    className: 'cursor-pointer',
  };

  if (subscription.daysFreeTrialLeft <= 0) {
    return <Alert {...buttonProps} type="error" message={`Your free trial expired. Click here to manage your subscription.`} />;
  }

  if (subscription.daysFreeTrialLeft <= 7) {
    return <Alert {...buttonProps} type="warning" message={`Free trial expiring soon, you have ${subscription.daysFreeTrialLeft} days left. Consider subscribing to avoid interruptions.`} />;
  }

  return <Alert type="success" showIcon message={`You still have ${subscription.daysFreeTrialLeft} more days to try all Bugal's features for free, but feel free to subscribe to a plan anytime!`} />;
}
